module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo/leo_vis-a6ab71e7160dc01dddb0967b3722e3a0.jpg";